/* eslint-disable import/no-unresolved */

import { useDevice } from 'hooks/useResponsive';

import InspectionPageMobile from './InspectionMobile';
import InspectionPageWeb from './InspectionWeb';

export default function Inspection() {
  const { isMobile } = useDevice();

  return <div>{isMobile ? <InspectionPageMobile /> : <InspectionPageWeb />}</div>;
}
